// Card and List Types
export const GRID_TYPE = 'grid';
export const LIST_TYPE = 'list';
export const CARD_TYPES = [GRID_TYPE, LIST_TYPE] as const;
export const FOLLOW_LIST_STYLES = [GRID_TYPE, LIST_TYPE] as const;

// Card Sizes
export const STANDARD_SIZE = 'standard';
export const MINI_SIZE = 'mini';
export const CARD_SIZES = [STANDARD_SIZE, MINI_SIZE] as const;

// Button Sizes
export const STANDARD_BUTTON_SIZE = 'standard';
export const COMPACT_BUTTON_SIZE = 'compact';
export const MINI_BUTTON_SIZE = 'mini';
export const FOLLOW_BUTTON_SIZES = [
    COMPACT_BUTTON_SIZE,
    MINI_BUTTON_SIZE,
    STANDARD_BUTTON_SIZE,
] as const;

// Button Styles
export const STANDARD_BUTTON_STYLE = 'standard';
export const SOLITARY_BUTTON_STYLE = 'solitary';
export const FOLLOW_BUTTON_STYLES = [
    STANDARD_BUTTON_STYLE,
    SOLITARY_BUTTON_STYLE,
] as const;

export const GLOBAL_NAV_HEIGHT = 60;

export type CardType = (typeof CARD_TYPES)[number];
export type FollowListStyle = (typeof FOLLOW_LIST_STYLES)[number];
export type CardSize = (typeof CARD_SIZES)[number];
export type FollowButtonSize = (typeof FOLLOW_BUTTON_SIZES)[number];
export type FollowButtonStyle = (typeof FOLLOW_BUTTON_STYLES)[number];
